import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatChannelCreatedEvent} from 'api/types/events'
import {NinchatState} from 'api/types'
import {extractProperties} from '.'

export const channelCreated: CaseReducer<NinchatState> = (state, action) => {
    const {
        channel_id,
        ...properties
    } = extractProperties<NinchatChannelCreatedEvent>(action.payload)

    state.user_channels[channel_id] = properties
}
